import React, { useEffect, useRef, useState } from "react";
import styleClasses from "./try2.module.scss";
import * as Constants from "../../constants";
import Spinner from "../../components/Spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  addTry2ComboSectionItem,
  addTry2ComboItem,
  try2ComboItemSelection,
  removeTry2ComboCategory,
  resetTry2ComboContext,
  swapTry2ComboContext,
  updatePriceForItem,
  removeTemporarilyAddedPriceForItem,
  updateTry2ComboSelectedModifiers,
  makeAnItemTry2Combo,
  resetContext,
  updateModifiers,
  updatePriceForAllItem,
  editTry2ComboItemSelection,
} from "../../redux/slices/itemCustomizationSlice";
import {
  ICoreModifiers,
  IRequiredModifiersGroupsModifiers,
} from "../../models/item.model";
import MakeSelection from "./subComponents/MakeASelection";
import ItemsSelections from "./subComponents/ItemsSelections";
import {
  INoDressingModifier,
  ISelectedItemDetailsForModal,
  ISelectedModifier,
  ITry2Combo,
} from "../../models/try2Combo";
import { useAppSelector } from "../../redux/store/store";
import { calculatePriceForItem } from "../../priceCalculation/calculatePrice";
import { itemBuckets } from "../../priceCalculation/buckets";
import { useAuthState } from "../../context/UserAuthentication";
import useAddToOrder from "../../hooks/useAddToOrder";
import { useStoreLocation } from "../../context/StoreLocation";
import { modifiersAgainstAnItem } from "../../priceCalculation/helper";
import LocationModal from "../../components/General/Modals/LocationModal";
import { availableModifiers, checkIfUserAddSecondItemAfterOne, createPayloadToSync, processEditItemModifiers, sortBasedOnPriceByModifierGroups, unavailableModifiers, verifyStatus } from "../../helpers/customizedItem/customizedItem.helper";
import useGetCartItem from "../../react-query-hooks/Cart/useGetCartItem";
import { IGetItemFromCartPayload } from "../../models/order.model";
import { getVisitorId } from "../../helpers/helperMethods";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import { useQueryClient } from "react-query";
import SelectLocationButton from "./LocationSelection/selectLocationButton";
import LocationSelectionModal from "./LocationSelection/locationSelectionModal";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import _debounce from 'lodash/debounce';
import AddedModal from "../order/AddedModal/AddedModal";
import { } from "../../components/utils";
import _clonedeep from 'lodash.clonedeep'
import { IItemBucket } from "../../priceCalculation/priceCalculation";
import { TBucketItemNo } from "../../models/types/items";
import {cartItem} from "../../models/cart.model";

const Try2Combo: React.FC<ITry2Combo> = ({
  item_id,
  location_id,
  category_id,
  hideScroll,
  favorites = [],
  favoriteButtonHandler,
  showCustomization,
  dbId,
  itemFromApi,
  selectedFilters,
  isFetching,
  name,
  autoScrollDivRef,
  setCategoryMenuVisibility,
  setItemDetailss,
  itemName,
  routeStates
}) => {
  const history = useHistory()
  const queryClient = useQueryClient()
  const dispatchItemCustomization = useDispatch();
  const order = useAppSelector((state: any) => state.itemCustomization);
  const { addToOrder, loading } = useAddToOrder();
  const { authInfo } = useAuthState();
  const [sectionSelected, setSectionSelected] = useState("");
  const [itemDetails, setItemDetails] = useState<boolean>(true);
  const [isResetTryToComboContext, setIsResetTryToComboContext] =
    useState<boolean>(false);
  const [addedItemInTry2Combo, setAddedItemInTry2Combo] = useState<string[]>(
    []
  );
  const [scrollToItems, setScrollToItems] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<string>(Constants.COMBO_ITEM_ONE);
  const [openOrderModal, setOpenOrderModal] = useState(false);
  const [successModalShow, setSuccessModalShow] = useState<boolean>(false);
  const [customizedItem, setCustomizedItem] = useState<cartItem>(null);

  const [try2ComboItemDetails, setTry2ComboItemDetails] = useState<ISelectedItemDetailsForModal[]>([{id:'1',itemName:null,image:null,is_selected:false},{id:'2',itemName:null,image:null,is_selected:false}]);


  const isThisMobile = useCheckMobileScreen()

  // const categoryScrollRef = useRef<HTMLDivElement>()
  const orderButtonScrollRef = useRef<HTMLDivElement>()

  const isOrderTypeSelected = useAppSelector(
    (state) => state.cart.isOrderTypeSelected
 );

  const recentlyDeletedId = useSelector((state: any) => state.cart.recentlyDeletedId);

  const closeOpenOrderModal = () => {
    setOpenOrderModal(false);
  };

  const payload : IGetItemFromCartPayload = {
    id: dbId,
    location_id: location_id
  }
  if( authInfo.userId ) payload.customer_id = authInfo.userId
  else payload.visitor_id = getVisitorId()

  const { data: editCartItem, refetch: fetchItem, isFetching: editItemFetching, isError,  } = useGetCartItem(payload);

  useEffect(()=>{
    if(!showCustomization || !dbId) return;
    if( recentlyDeletedId === Number(dbId) || isError) {
      toast.error("This Item does not exist!")
      resetTry2Combo()
    }
  },[recentlyDeletedId ,isError])

  const [showLocationModal, setShowLocationModal] = useState<boolean>(!isOrderTypeSelected);


  const { locationInfo } = useStoreLocation();
  const [selectedLocation, setSelectedLocation] = useState(
    locationInfo.selectedStore
  );
  const [location, setLocation] = useState<boolean>(true);

  // Check if the Location is Selected or Not
  useEffect(() => {
    if (selectedLocation) {
      setLocation(true);
    } else {
      setLocation(false);
    }
  });

  useEffect(()=>{
    if(showCustomization && dbId) {
      console.log("msg","only run in edit case")
      dispatchItemCustomization(resetContext());
      itemBuckets.createComboBucket(
        {
          keys: [
            Constants.REQUIRED_MODIFIERS,
            Constants.CORE_MODIFIERS,
            Constants.ADD_ONS,
            Constants.COMPLIMENTARY_MODIFIER
          ],
          items: 2
        }
      );
      fetchItem()
    }
  },[showCustomization, dbId])

  // ? Check if itemDetails then show ScrollBar on top
  useEffect(() => {
    hideScroll(itemDetails);
  }, [itemDetails]);

  useEffect(() => {
    return () => {
      itemBuckets.resetBuckets();
      dispatchItemCustomization(resetContext());
    };
  }, []);

  const createBucketForAlreadySelectedItem = (bucket: IItemBucket[], item: any) => {
    itemBuckets.addExisitngItemToBucket({items:bucket});
    setSectionSelected(Constants.COMBO_ITEM_ONE)
    setSelectedItem(Constants.COMBO_ITEM_ONE)
    setAddedItemInTry2Combo([...addedItemInTry2Combo, Constants.COMBO_ITEM_ONE]);
    decideCardSelection([],Constants.COMBO_ITEM_ONE);
    dispatchItemCustomization(makeAnItemTry2Combo());
    dispatchItemCustomization(
      try2ComboItemSelection({ sectionSelected:Constants.COMBO_ITEM_ONE, item, itemName: Constants.TRY_2_COMBO })
    );
  };
  //Wrapper function to sync ingredients
  const handleInitialSync = async ( IsNotEdit  = false ) => {
    if( showCustomization && ( !editCartItem )) return;
    const zeroPriceCore = [];
    if(itemFromApi?.items[0]) await handleTry2ComboComplimentaryModifiers(itemFromApi?.items[0])
    if(showCustomization && editCartItem && !IsNotEdit){
      // dispatchItemCustomization(addTry2ComboItem(itemFromApi?.items[0]));
      await processEditItemModifiers(editCartItem, itemFromApi?.items[0],Constants.TRY_TO_COMBO_ITEM, 3)
      for( let i = 0; i < Constants.TRY_TO_COMBO_SELECTED_SECTION ; i++){
        let cartItem = editCartItem.modifiers[i]
        if(!cartItem.is_item) return;
        const categoryId = cartItem.category_id
        let section = (i+1).toString()
        const category = itemFromApi?.items[0].sub_categories.find(category => category.id === categoryId)
        const item = category.items.find(categoryItem => categoryItem.id === cartItem.modifier_id )
        itemBuckets.addCoreModifierMemoryChip(i+1, item.bucket, item?.items_modifier_groups);
        await handleSyncIngredients(item, i+1, cartItem, zeroPriceCore);
        await processEditItemModifiers(cartItem, item,Constants.TRY_TO_COMBO_ITEM, i + 1);
        await handleZeroCore(zeroPriceCore)
        if ( cartItem.no_required_modifier) await handleNoDressing(cartItem.no_required_modifier, section)
      }
      setAddedItemInTry2Combo([Constants.COMBO_ITEM_ONE, Constants.COMBO_ITEM_TWO]);
      setSelectedItem('');
      setItemDetails(true);
      setCategoryMenuVisibility(true);
      setItemDetailss(true);
    }
    await updateModifierStates()
    if(showCustomization && editCartItem && !IsNotEdit){
    await editItemToTrytoCombo()
    }
  };

  const handleZeroCore = async (zeroPriceCore:{customizedIngredient:any,data:any,iterations:number, quantity:number, itemID:any }[]) => {
    zeroPriceCore.forEach(element => {
      const {customizedIngredient,data,iterations, quantity, itemID: id} = element;
      const item_id: any = parseInt(id ?? selectedItem);
      for (let j = 0; j < iterations; j++) {
        let tempQuantity = 0
        if( customizedIngredient ) data.code = customizedIngredient.code
        if ( data.code === Constants.ADD ) {
          tempQuantity = j + 1
          data.type = j === 0 ? Constants.BY_DEFAULT : Constants.INCREASE
          data.code = Constants.ADD
        } else if ( data.code === Constants.NO ) {
          data.type = Constants.DECREASE
          tempQuantity = 0
        } else {
          tempQuantity = quantity
        }
        calculatePriceForItem({currentModifier:{...data, quantity: tempQuantity }, item_id});
        if( data.code === Constants.NO ) break;
      }
    });
  }

  const editItemToTrytoCombo = async () => {
    for( let i = 0; i < Constants.TRY_TO_COMBO_SELECTED_SECTION ; i++){
      let cartItem = editCartItem.modifiers[i]
      if(!cartItem.is_item) return;
      const categoryId = cartItem.category_id
      let section = (i+1).toString()
      const category = itemFromApi?.items[0].sub_categories.find(category => category.id === categoryId)
      const item = category.items.find(categoryItem => categoryItem.id === cartItem.modifier_id )
      dispatchItemCustomization(editTry2ComboItemSelection({ id: editCartItem.id, sectionSelected : section, item, category: category, itemName: Constants.TRY_2_COMBO }));
    }
  }

  const updateModifierStates = async () => {
    const modifierPrices = []
    const itemBucket = itemBuckets.getBuckets();
    for( let i = 0; i< itemBucket.length; i++) {
      const currentItemBucket = itemBucket[i]
      const bucketTypes = Object.keys(currentItemBucket?.bucket);
      for( let i = 0; i< bucketTypes.length; i++) {
       const type = bucketTypes[i]
       const activeBucket = currentItemBucket?.bucket[type]
       const itemId = currentItemBucket?.item === 3 ? Constants.COMPLEMENTARY_ITEM : currentItemBucket?.item
       modifierPrices.push({ activeBucket, itemId})
      }
    }
    const firstItem = modifiersAgainstAnItem({itemType: Constants.TRY_TO_COMBO_ITEM, itemId: Constants.TRY_TO_COMBO_SELECTED_SECTION_FIRST_SECTION})
    const secondItem = modifiersAgainstAnItem({itemType: Constants.TRY_TO_COMBO_ITEM, itemId: Constants.TRY_TO_COMBO_SELECTED_SECTION})
    const complimentaryModifiers = modifiersAgainstAnItem({itemType: Constants.COMPLEMENTARY_ITEM, itemId: Constants.COMPLEMENTARY_SELECTED_SECTION_FOR_TRY_TO_COMBO_ITEM})
    const modifiers = []
    
    modifiers.push({ itemModifiers: firstItem, itemId: 1})
    modifiers.push({ itemModifiers: secondItem, itemId: 2})
    modifiers.push({ itemModifiers: complimentaryModifiers, itemId: Constants.COMPLEMENTARY_ITEM})
    dispatchItemCustomization(updateModifiers(modifiers))
    dispatchItemCustomization(updatePriceForAllItem(modifierPrices))
  }

  const updateSingleBucket = (itemNo: 1|2|3) => {
    const priceArray = [];
    let updatedBucketId:any = itemNo;
    const itemBucket = itemBuckets.getSingleItem({itemType: Constants.TRY_TO_COMBO_ITEM , itemNo});
    const bucketTypes = Object.keys(itemBucket?.bucket);
    bucketTypes.forEach(type => {
      const activeBucket = itemBucket?.bucket[type]
      priceArray.push({ activeBucket, itemId: itemNo, isCustomize: true})
    });
    const itemModifiers = modifiersAgainstAnItem({ itemType: Constants.TRY_TO_COMBO_ITEM ,itemId :itemNo})
    const modifiers = []
    if(itemNo === Constants.COMPLEMENTARY_SELECTED_SECTION_FOR_TRY_TO_COMBO_ITEM){
      updatedBucketId = Constants.COMPLEMENTARY_ITEM
    }
    modifiers.push({ itemModifiers, itemId: updatedBucketId})
    dispatchItemCustomization(updateModifiers(modifiers))
    dispatchItemCustomization(updatePriceForAllItem(priceArray))
  }

  const handleScroll = () => {
    const isBothItemSelected = checkIfUserAddSecondItemAfterOne(order)
    if(isBothItemSelected && isThisMobile) {
      scrollDescritionToCenter(15)
    }
    // else document.documentElement.scrollTop = 0;  //? uncomment this and adjust scroll if you have to add when second item selection 
  };

  const shouldRender = () => {
    return order.id != item_id && !isFetching && itemFromApi?.items[0] && !dbId && !showCustomization && order?.makeAnItemTry2Combo?.bucket
  }

  useEffect(() => {
    if (shouldRender()) {
      console.log("msg","only run when making an item combo")
      dispatchItemCustomization(addTry2ComboItem(itemFromApi?.items[0]));
      itemBuckets.createComboBucket(
        {
          keys:
            [
              Constants.REQUIRED_MODIFIERS,
              Constants.CORE_MODIFIERS,
              Constants.ADD_ONS,
              Constants.COMPLIMENTARY_MODIFIER
            ],
          items: 2
        }
      );
      // itemFromApi?.items[0] && handleInitialSync()
    }
  }, [isFetching]);

  useEffect(() => {
    if(shouldRender() && order?.modifiers?.length === 3){
      console.log("msg","only run when making an item combo")
      if(itemFromApi?.items[0]) handleTry2ComboComplimentaryModifiers(itemFromApi?.items[0])
      const selectedItemBucket = order?.makeAnItemTry2Combo;
      const itemDetails:ISelectedItemDetailsForModal[] = try2ComboItemDetails?.map((currentItem) => {
        if(currentItem.id === '1'){
          currentItem.is_selected = true;
          currentItem.itemName = selectedItemBucket?.item?.name;
          currentItem.image = selectedItemBucket?.item?.image
        }
        return currentItem
      })
      setTry2ComboItemDetails(itemDetails)
      if (selectedItemBucket?.bucket) {
        createBucketForAlreadySelectedItem(
          selectedItemBucket?.bucket,
          selectedItemBucket?.item
        );
      }
      updateSingleBucket(3)
    }
  },[order?.modifiers?.length])

  useEffect(() => {
    if(editCartItem && showCustomization && itemFromApi?.items[0] && dbId && order.id != dbId && editCartItem?.id == dbId){
      console.log("msg","only run in edit case")
      dispatchItemCustomization(addTry2ComboItem(itemFromApi?.items[0]));
      handleInitialSync()
    }
  }, [itemFromApi, editCartItem, dbId]);

  useEffect(() => {
    if(!dbId && selectedItem === ''){
      console.log('msg','only run when click on tab')
      setSelectedItem(Constants.COMBO_ITEM_ONE)
      setSectionSelected('1');
      setAddedItemInTry2Combo([]);
    }
  },[dbId])

  useEffect(() => {
      if(!dbId && !isFetching && !order?.makeAnItemTry2Combo?.bucket && itemFromApi?.items[0]){
      console.log('msg','only run when working on try2combo')
      dispatchItemCustomization(addTry2ComboItem(itemFromApi?.items[0]));
        itemBuckets.createComboBucket(
          {
            keys: [
              Constants.REQUIRED_MODIFIERS,
              Constants.CORE_MODIFIERS,
              Constants.ADD_ONS,
              Constants.COMPLIMENTARY_MODIFIER
            ],
            items: 2
          }
        );
      itemFromApi?.items[0] && handleInitialSync();
    }
  }, [isFetching,dbId]);

  const handleItemSelection = (args) => {
    dispatchItemCustomization(
      addTry2ComboSectionItem({
        ...args,
        section: sectionSelected,
        modifiers: [],
      })
    );
  };

  const addItemtoCombo = (item:any) => {
    const itemDetails:ISelectedItemDetailsForModal[] = try2ComboItemDetails?.map((currentItem) => {
      if(currentItem.id === selectedItem){
        currentItem.is_selected = true;
        currentItem.itemName = item?.name;
        currentItem.image = item?.image
      }
      return currentItem
    })
    setTry2ComboItemDetails(itemDetails)
    scrollDescritionToCenter(0)
    setAddedItemInTry2Combo([...addedItemInTry2Combo, selectedItem]);
    decideCardSelection();
    handleScroll();
    dispatchItemCustomization(
      try2ComboItemSelection({ sectionSelected, item, itemName: Constants.TRY_2_COMBO })
    );
  };

  const decideCardSelection = (
    items = addedItemInTry2Combo,
    selected = sectionSelected
  ) => {
    if (selected === Constants.COMBO_ITEM_ONE && items.includes(Constants.COMBO_ITEM_TWO)) {
      setSelectedItem('');
    } else if (selected === Constants.COMBO_ITEM_TWO && items.includes(Constants.COMBO_ITEM_ONE)) {
      setSelectedItem('');
    } else if (selected === Constants.COMBO_ITEM_ONE) {
      setSelectedItem(Constants.COMBO_ITEM_TWO);
    } else {
      setSelectedItem(Constants.COMBO_ITEM_ONE);
    }
  };

  const clickOnItemsAfterCategorySelection = (onRemove:boolean) => {
    const addedInCombo = [];
    for (let i = 0; i < order?.modifiers.length - 1; i++) {
      if (order?.modifiers[i].category_id !== null) {
        if (order?.modifiers[i].id !== null) {
          addedInCombo.push(true);
        } else {
          addedInCombo.push(false);
        }
      }
    }
    const checkCondition = onRemove ? addedInCombo.includes(false) : addedInCombo.includes(false) && !addedInCombo.includes(true);
    if (checkCondition) {
      return true;
    } else {
      return false;
    }
  };

  const scrollDescritionToCenter = (value:number) => {
    autoScrollDivRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
    const elementRect = autoScrollDivRef?.current?.getBoundingClientRect();
    if(elementRect){
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / value);
      window.scrollTo(0, middle);
    }
  }

  const onItemSelectionChange = (id: string, scroll=true) => {
    if(scroll && itemDetails){
      isThisMobile && scrollDescritionToCenter(4.2)
    }
    if (clickOnItemsAfterCategorySelection(false)) {
      dispatchItemCustomization(swapTry2ComboContext());
    }
    setSectionSelected(id);
    setSelectedItem(id);
  };

  const onRemoveClickHandler = (id) => {
    const itemDetails:ISelectedItemDetailsForModal[] = try2ComboItemDetails?.map((currentItem) => {
      if(currentItem.id === id){
        currentItem.is_selected = false;
        currentItem.itemName = null;
        currentItem.image = null
      }
      return currentItem
    })
    setTry2ComboItemDetails(itemDetails)
    if (clickOnItemsAfterCategorySelection(true)) {
      removeSingleCategory(id);
      dispatchItemCustomization(resetTry2ComboContext());
      setItemDetails(true);
      setCategoryMenuVisibility(true);
      setItemDetailss(true);
      setIsResetTryToComboContext(true);
      setSelectedItem(Constants.COMBO_ITEM_ONE);
    } else {
      removeSingleCategory(id);
      dispatchItemCustomization(removeTry2ComboCategory({ id }));
    }
  };

  const removeSingleCategory = (id) => {
    let addedItems = [...addedItemInTry2Combo];
    const index = addedItemInTry2Combo.findIndex((item) => item === id);
    if (index > -1) {
      setAddedItemInTry2Combo(
        addedItemInTry2Combo.filter((item) => item !== id)
      );
      addedItems = addedItems.filter((item) => item !== id);
    }
    decideCardSelection(addedItems, id === Constants.COMBO_ITEM_ONE ? Constants.COMBO_ITEM_TWO : Constants.COMBO_ITEM_ONE);
  };

  // Wrapper function for add ingredients
  const handleIngredientSelection: (
    data: any | ISelectedModifier,
    id?: any
  ) => void = (data, id = sectionSelected) => {
    const { itemId, activeBucket, itemModifiers } = calculatePriceForItem(
      {currentModifier:data,
      item_id:id}
    );
    dispatchItemCustomization(
      updateTry2ComboSelectedModifiers({ itemModifiers, itemId })
    );
    if (activeBucket !== undefined) {
      dispatchItemCustomization(updatePriceForItem({ itemId, activeBucket }));
    }
  };

  // Wrapper function for add ingredients
  const handleComplementaryIngredientSelection: (
    data: any,
    id?: 1|2|3|4
  ) => void = (data, id = Constants.COMPLEMENTARY_SELECTED_SECTION_FOR_TRY_TO_COMBO_ITEM) => {
    const { itemId, activeBucket, itemModifiers } = calculatePriceForItem(
      {
        currentModifier: data,
        item_id: id
      }
    );
    dispatchItemCustomization(
      updateTry2ComboSelectedModifiers({ itemModifiers, itemId })
    );
    if (activeBucket !== undefined) {
      dispatchItemCustomization(updatePriceForItem({ itemId, activeBucket }));
    }
  };

  const handleSelectedModifiers = async (item: any, bucketId: 1|2|3|4 = 1) => {
    const selectedModifiers = item.is_selected
    selectedModifiers.forEach(selectedItem => {
      let payload = createPayloadToSync({...selectedItem, modifier_type: Constants.CORE_MODIFIERS}, item)
      calculatePriceForItem({currentModifier:payload,item_id: bucketId});
    });
    return true;
  }

  const handleTry2ComboComplimentaryModifiers = async (item: any) => {
    const complimentaryModifiers = item.complementary_items ?? []
    complimentaryModifiers.forEach(modifier => {
      modifier.modifiers_groups_modifiers?.forEach(selectedItem => {
        if( !selectedItem.is_selected) return;
        let payload = createPayloadToSync({...selectedItem, modifier_type: Constants.COMPLIMENTARY_MODIFIER}, item)
        calculatePriceForItem({currentModifier:payload,item_id: Constants.COMPLEMENTARY_SELECTED_SECTION_FOR_TRY_TO_COMBO_ITEM});
      });
    });
    return true;
  }

  const handleSyncIngredients = async (item, id=null, cartItem=null, zeroPriceCore=[]) => {
    const itemID =id ? id :  parseInt(selectedItem)
    let ingredients = _clonedeep(availableModifiers(item));
    if(ingredients.length){
      ingredients = sortBasedOnPriceByModifierGroups(ingredients)
    }
    for (let i = 0; i < ingredients.length; i++) {
      let customizedIngredient = null
      let iterations = 1;
      let quantity = parseInt(ingredients[i].quantity) || 1
      const data : any = {
        modifier_id: ingredients[i].id,
        modifier_name: ingredients[i].name,
        modifier_group_id: ingredients[i].modifier_group_id,
        modifier_calories: ingredients[i].calories,
        brink_id: ingredients[i].brink_modifier_id,
        quantity: quantity,
        brink_modifier_group_id: ingredients[i].brink_modifier_group_id,
        display_price: ingredients[i].price,
        core: true,
        type: Constants.BY_DEFAULT,
        modifier_type: Constants.CORE_MODIFIERS,
      };
      //In case of Edit update core modifier selection
      if( showCustomization && cartItem?.core_modifiers ){
        let customizedIngredients = _clonedeep(cartItem.core_modifiers ?? []);
        if(customizedIngredients.length){
          customizedIngredients = sortBasedOnPriceByModifierGroups(customizedIngredients)
        }
        customizedIngredient = customizedIngredients.find((mod)=>mod.modifier_id === ingredients[i].id);
      }
      iterations = customizedIngredient?.quantity > 1 ? customizedIngredient?.quantity : 1;
      // save zero price core to add them at the end
      if(customizedIngredient?.price === 0 && showCustomization && editCartItem?.core_modifiers) { 
        zeroPriceCore.push({customizedIngredient, data, iterations, quantity, itemID});
        continue
      }
      for (let j = 0; j < iterations; j++) {
        let tempQuantity = 0
        if( customizedIngredient ) data.code = customizedIngredient.code
        if ( data.code === Constants.ADD ) {
          tempQuantity = j + 1
          data.type = j === 0 ? Constants.BY_DEFAULT : Constants.INCREASE
          data.code = Constants.ADD
        } else if ( data.code === Constants.NO ) {
          data.type = Constants.DECREASE
          tempQuantity = 0
        } else {
          tempQuantity = quantity
        }
        calculatePriceForItem({currentModifier:{...data, quantity: tempQuantity }, item_id: id ?? selectedItem});
        if( data.code === Constants.NO ) break;
      }
    }
    await handleSelectedModifiers(item,itemID)
    await handleSync86Ingredients(item, itemID)
    if( !id ) updateSingleBucket(itemID)
    
  };

  const handleSync86Ingredients = async (item, bucketId) => {
    const ingredients = unavailableModifiers(item);
    for (let i = 0; i < ingredients.length; i++) {
      const data:any = {
        modifier_id: ingredients[i].id,
        modifier_name: ingredients[i].name,
        modifier_group_id: ingredients[i].modifier_group_id,
        modifier_group_min: ingredients[i].modifier_group_min,
        modifier_calories: ingredients[i].calories,
        brink_id: ingredients[i].brink_modifier_id,
        quantity: 0,
        brink_modifier_group_id: ingredients[i].brink_modifier_group_id,
        display_price: ingredients[i].price,
        type: Constants.DECREASE,
        modifier_type: Constants.CORE_MODIFIERS,
      };
      const itemId: 1|2|3 = parseInt(bucketId) as 1|2|3;
      calculatePriceForItem({currentModifier:data, item_id:itemId});
      return true;
    }
  };

  const resetTry2Combo = () => {
    history.replace(`${Constants.ROUTE_MENU}/${Constants.TRY_2_COMBO_CAPITALIZE}`,{
      showCustomization: false
    })
    queryClient.resetQueries("get-cart-item")
    dispatchItemCustomization(resetContext());
    dispatchItemCustomization(addTry2ComboItem(itemFromApi?.items[0]));
    itemBuckets.createComboBucket(
      {
        keys: [
          Constants.REQUIRED_MODIFIERS,
          Constants.CORE_MODIFIERS,
          Constants.ADD_ONS,
          Constants.COMPLIMENTARY_MODIFIER
        ],
        items: 2
      }
    );
    setSectionSelected('1');
    setSelectedItem(Constants.COMBO_ITEM_ONE);
    setItemDetails(true);
    setCategoryMenuVisibility(true);
    setItemDetailss(true);
    setAddedItemInTry2Combo([]);
    setIsResetTryToComboContext(false);
    itemFromApi?.items[0] && handleInitialSync(true)
  };

  const handleAddToOrder = async (structuredOrder) => {
    const response = await addToOrder(structuredOrder, true, structuredOrder?.quantity);
    if (response){
        setCustomizedItem(structuredOrder)
      !dbId && setSuccessModalShow(true)
      resetTry2Combo();
    }
  };

  const noDressingHandler = (modifier: INoDressingModifier, itemNo) => {
    dispatchItemCustomization(
      removeTemporarilyAddedPriceForItem({
        price: itemBuckets.resetChangesOnNoDreesing(itemNo, modifier),
        item: itemNo,
      })
    );
    dispatchItemCustomization(updateTry2ComboSelectedModifiers({itemModifiers:modifiersAgainstAnItem({itemType:Constants.TRY_TO_COMBO_ITEM, itemId:itemNo}), itemId:itemNo}))
    itemBuckets.consoleBuckets();
  };

  const handleNoDressing = (modifiers:any,itemNo) => {
    for ( let i = 0; i < modifiers.length ; i++ ){
      itemBuckets.resetChangesOnNoDreesing(itemNo,{ ...modifiers[i] , quantity: 1})
    }
  };

  const unrepeatedIngredients: (
    | ICoreModifiers
    | IRequiredModifiersGroupsModifiers
  )[] = itemFromApi?.items[0]
    ? [
        ...itemFromApi?.items[0].core_modifiers,
        ...itemFromApi?.items[0].items_required_modifier_groups
          .map((group) => group.required_modifiers_groups_modifiers)
          .flat(),
      ]
    : [];

  return isFetching || editItemFetching ? (
    <div className={styleClasses.try2_loader_wrapper}>
      <Spinner AlignSpinner={"align-spiner-center"}/>
    </div>
  ) : (
    <div
      className={`${styleClasses.try2_wrapper} try2-wrapper pt-156`}
      id="try2combo_home_page"
    >      
      <LocationModal 
        showModal={showLocationModal} 
        setShowModal={setShowLocationModal} 
        itemPath={ {
          pathname: `${Constants.ROUTE_MENU}/${name}`,
          search: '',
          state: {}
        }}
      />
      <MakeSelection
        sectionSelected={sectionSelected}
        setSectionSelected={(id,scroll) => onItemSelectionChange(id,scroll)}
        order={order}
        itemFromApi={itemFromApi?.items[0]}
        category={itemFromApi}
        itemDetails={itemDetails}
        selectedItem={selectedItem}
        onRemoveClickHandler={onRemoveClickHandler}
        handleIngredientSelection={handleIngredientSelection}
        handleSyncIngredients={(item) => handleSyncIngredients(item)}
        noDressingHandler={noDressingHandler}
        selectedLocation={selectedLocation}
        DescriptionScrollRef={autoScrollDivRef}
      />
      {itemFromApi?.items[0] && itemBuckets.getBuckets()?.length > 0 && (
              <ItemsSelections
              sectionSelected={sectionSelected}
              itemFromApi={itemFromApi?.items[0]}
              selectedFilters={selectedFilters}
              unrepeatedIngredients={unrepeatedIngredients}
              loading={loading}
              handleIngredientSelection={handleIngredientSelection}
              handleComplementaryIngredientSelection={
                handleComplementaryIngredientSelection
              }
              order={order}
              addToOrder={handleAddToOrder}
              handleItemSelection={handleItemSelection}
              item_id={item_id}
              setItemDetails={(state) => {
                setCategoryMenuVisibility(state);
                setItemDetailss(state);
                setItemDetails(state)
              }}
              isResetTryToComboContext={isResetTryToComboContext}
              setIsResetTryToComboContext={(state) =>
                setIsResetTryToComboContext(state)
              }
              addItemtoCombo={(id) => addItemtoCombo(id)}
              handleSyncIngredients={(item) => handleSyncIngredients(item)}
              handleScroll={handleScroll}
              favourite={favorites}
              favoriteButtonHandler={favoriteButtonHandler}
              userId={authInfo?.userId}
              noDressingHandler={noDressingHandler}
              setScrollToItems={(state: boolean) => setScrollToItems(state)}
              scrollToItems={scrollToItems}
              selectedLocation={location}
              category_id={parseInt(category_id)}
              showCustomization={showCustomization}
              userType={authInfo?.type}
              categoryScrollRef={autoScrollDivRef}
              orderButtonScrollRef={orderButtonScrollRef}
              itemDetails={itemDetails}
              editItemQuantity={dbId && editCartItem?.quantity}
              recipient_name={dbId && editCartItem?.recipient_name}
              routeStates={routeStates}
            />
      )}
        <SelectLocationButton
          selectedLocation={selectedLocation}
          setOpenOrderModal={(state: boolean) => setOpenOrderModal(state)}
        />
        {successModalShow && <AddedModal
            item={customizedItem}
            itemFromApi={itemFromApi}
            showModal={successModalShow} closeModal={() => {
          setSuccessModalShow(false);
          setTry2ComboItemDetails([{id:'1',itemName:null,image:null,is_selected:false},{id:'2',itemName:null,image:null,is_selected:false}])
          }} name={itemFromApi?.items[0]?.name} image={`${Constants.REACT_APP_CLOUD_FRONT}${itemFromApi?.items[0]?.image}`} isCombo={true} comboItems={try2ComboItemDetails} styleTitle="f-s26 f-sm-s22" styleName="text-uppercase f-s18 font-Visby-cf" />
        }
        <LocationSelectionModal
          isOrderTypeSelected={isOrderTypeSelected}
          openOrderModal={openOrderModal}
          closeOpenOrderModal={closeOpenOrderModal}
          itemPath={{
            pathname: `${Constants.ROUTE_MENU}/${name}`,
            search: '',
            state: {}
          }}
        />
    </div>
  );
};

export default Try2Combo;